import { createAction } from "@ngrx/store";

export const LoadingStatusActions = {
    start: createAction("[LoadingStatus] Start"),
    end: createAction("[LoadingStatus] End"),
};
